import ToolTipInformation from 'Components/ToolTipInformation/ToolTipInformation'
import React from 'react'

export const DocumentTypeTooltipNatural = ({ style = {} }) => {
  return (
    <ToolTipInformation
      style={style}
      message={
        <div>
          <p style={{ fontSize: '12px' }}>
            Selecciona el tipo de documento apropiado según el perfil del
            cliente.
          </p>
          <br />
          <p style={{ fontSize: '12px' }}>
            Cédula: Debe ser alfanumérico, comenzar con un número lel 1 al 13 o
            con una de las letras (N, PE, E, PI), seguido de un guión. No se
            permiten dos guiones seguidos, espacios, puntos ni ningún otro
            carácter que no sean guiones
          </p>
          <br />

          <p style={{ fontSize: '12px' }}>
            Pasaporte: Debe ser alfanumérico y no debe contener caracteres
            especiales ni espacios.
          </p>
          <br />

          <p style={{ fontSize: '12px' }}>
            NT (Número de Identificación Tributaria): Debe ser fanumérico,
            comenzar con un número del 1 al 13, seguido de un guión. Se permiten
            espacios, pero no se permiten dos guiones seguidos, puntos ni ningún
            otro carácter que no sean guiones.
          </p>
        </div>
      }
    />
  )
}

export const EmailTooltip = ({ style = {} }) => {
  return (
    <ToolTipInformation
      style={style}
      message={
        <p style={{ fontSize: '12px' }}>
          {`El correo electrónico debe contener una '@'. No se permiten espacios
          en blanco. Asegúrate de revisar que haya quedado bien escrito antes de
          guardar`}
        </p>
      }
    />
  )
}

export const PhoneTypeTooltip = ({ style = {} }) => {
  return (
    <ToolTipInformation
      style={style}
      message={
        <div>
          <p style={{ fontSize: '12px' }}>
            Para el tipo de teléfono, selecciona una opción del catálogo:
            Celular, Casa u Oficina.
          </p>
          <br />
          <p style={{ fontSize: '12px' }}>
            Asegúrate de ingresar solo números, sin guiones ni caracteres
            especiales, ni espacios.
          </p>
          <br />

          <p style={{ fontSize: '12px' }}>
            {`Para teléfono Celular: Debe comenzar con '6' y tener 8 dígitos en
            total.`}
          </p>

          <p style={{ fontSize: '12px' }}>
            {`Para teléfono Casa u Oficina: No debe comenzar con 'O', '1' o '6', y
            tiene 7 dígitos en total.`}
          </p>
        </div>
      }
    />
  )
}

export const BirthdayTooltip = ({ style = {} }) => {
  return (
    <ToolTipInformation
      style={style}
      message={
        <p style={{ fontSize: '12px' }}>
          {`Utiliza el formato DD/MM/AAAA.
            El cliente debe ser mayor de 18 años.
            Si es un cliente nuevo, la edad debe ser menor de 100 años.`}
        </p>
      }
    />
  )
}

export const DocumentTypeTooltipLegal = ({ style = {} }) => {
  return (
    <ToolTipInformation
      style={style}
      message={
        <div>
          <p style={{ fontSize: '12px' }}>
            Selecciona el tipo de documento apropiado según el perfil del
            cliente.
          </p>
          <br />
          <p style={{ fontSize: '12px' }}>
            RUC (Registro Único de Contribuyentes): Debe ser alfanumérico y
            seguir el formato de tres áreas de dígitos separadas por guiones
            (X-XXX-XXXXXXXXX).
          </p>
          <br />

          <p style={{ fontSize: '12px' }}>
            Cédula: Debe ser alfanumérico, comenzar con un número del 1 al 13 o
            con una de las letras (N, PE, E, PI), seguido de un guión. No se
            permiten dos guiones seguidos, espacios, puntos ni ningún otro
            carácter que no sean guiones.
          </p>
          <br />

          <p style={{ fontSize: '12px' }}>
            NT Gobierno: Debe ser alfanumérico, comenzar con un número del 1 al
            13, seguido de un guión. Se permiten espacios, pero no se permiten
            dos guiones seguidos, puntos ni ningún otro carácter que no sean
            guiones.
          </p>
          <br />

          <p style={{ fontSize: '12px' }}>
            NT (Número de Identificación Tributaria): Debe ser alfanumérico,
            comenzar con un número del 1 al 13, seguido de un guión. Se permiten
            espacios, pero no se permiten dos guiones seguidos, puntos ni ningún
            otro carácter que no sean guiones.
          </p>
        </div>
      }
    />
  )
}
